import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { Controller } from 'react-hook-form';

import MaterialTheme from 'theme';
import { useStyles } from './styles';
import { useInsurers } from 'hooks/useInsurers';

const QuoteType: React.FC<any> = ({
  control,
  quoteType,
  disabledInsures,
  disabledQuoteType,
  setValue,
}) => {
  const classes = useStyles();
  const { filteredInsurers } = useInsurers();

  const animatedComponents = makeAnimated();

  const SelectTheme = (theme: any) => ({
    ...theme,
    colors: {
      ...theme.colors,
      text: 'orangered',
      primary: MaterialTheme.palette.primary.main,
    },
  });

  React.useEffect(() => {
    if (setValue && filteredInsurers.length > 0) {
      setValue('selectedInsurers', filteredInsurers);
    }
  }, [filteredInsurers, setValue]);

  return (
    <>
      <Grid item xs={12} sm={8}>
        <Typography className={classes.label}>Aseguradoras</Typography>
        <Controller
          name="selectedInsurers"
          as={Select}
          placeholder="Seleccionar..."
          closeMenuOnSelect={false}
          components={animatedComponents}
          isMulti
          options={filteredInsurers}
          isDisabled={disabledInsures}
          theme={SelectTheme}
          control={control}
        />
      </Grid>
    </>
  );
};

export default QuoteType;
